// ** MUI Components
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";

// ** Layout Import
import BlankLayout from "../../Layout/blankLayout.js";
import Tooltip from "@mui/material/Tooltip";

// ** Demo Components Imports
import RegisterMultiStepsWizard from "../onboarding/register-multi-steps";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Icon } from "@iconify/react";
import Progression from "images/Progression.svg";
import PersonalDetails from "images/PersonalDetails.png";
import CompanyDetails from "images/CompanyDetails.png";
import InviteUsers from "images/InviteUsers.jpg";
import { GetOnboardingStatus } from "components/logic/paymentgateway/GetOnboardingStatus.js";
import { Backdrop, CircularProgress } from "@mui/material";


const RegisterMultiSteps = () => {
  // ** Hooks
  const theme = useTheme();
  const navigate = useNavigate();

  // const [isLoading, setIsLoading] = useState(false);
  // const [activeStep, setActiveStep] = useState(0);
  // const [displayWelcomeScreen, setDisplayWelcomeScreen] = useState(true);
  // const [isLoading, setIsLoading] = useState(false);
  // const [activeStep, setActiveStep] = useState(0);
  // const [displayWelcomeScreen, setDisplayWelcomeScreen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [wasReloaded, setWasReloaded] = useState(false);

  // pull any step / skipWelcome flags from navigate(...)
  const location    = useLocation();
  const locState    = location.state || {};
  const skipWelcome = Boolean(locState.skipWelcome);
  // only jump into a non‐zero step if skipWelcome===true:
  const initialStep = skipWelcome && typeof locState.step === "number"
    ? locState.step
    : 0;     
  
  console.log('Parent Onboarding - location.state:', locState, 'initialStep:', initialStep);

  const [activeStep, setActiveStep] = useState(initialStep);
  const totalSteps = 10;
  const progressPercent = Math.min(((activeStep + 1) / totalSteps) * 100, 100);
  const [isAuthorized, setIsAuthorized] = useState(false);
 

  const backgroundpath = {
    0: PersonalDetails,
    1: CompanyDetails,
    4: InviteUsers,
  };

    const [User, setUser] = useState({});
  
    useEffect(() => {
        const getUserData = async()=>{
          const response = await GetOnboardingStatus(navigate);
          if(!response.isError){
            setUser(response.result);
          }else{
            setUser({});
            console.error("Error fetching user data:", response.message);
          }
        }
        getUserData();
    
      },[User?.fullName]);
      

  useEffect(() => {
    if (User?.roleType) {
      const allowedRoles = ['Admin', 'Owner', 'Manager'];
      const hasAccess = allowedRoles.includes(User.roleType);
      setIsAuthorized(hasAccess);
      
      if (!hasAccess) {
        navigate('/dashboard');
      }
    }
  }, [User?.roleType, navigate]);         

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      navigate("/login", { state: { message: "Please login to continue." } }); // Redirect to login if token is not found
    } else {
      setIsLoading(false); // Set loading to false if token is found
    }
  }, [navigate]);

  // Update activeStep when navigating back with state (e.g., from employee upload)
  // Skip this if page was reloaded (reload takes precedence)
  useEffect(() => {
    if (!wasReloaded && skipWelcome && typeof locState.step === "number") {
      console.log('Navigation detected with state - updating to step:', locState.step);
      setActiveStep(locState.step);
    }
  }, [locState.step, skipWelcome, wasReloaded]);

  useEffect(() => {
    let isReload = false;
    // modern API
    if (performance.getEntriesByType) {
      const nav = performance.getEntriesByType("navigation");
      if (nav.length && nav[0].type === "reload") isReload = true;
    }
    // fallback older browsers
    else if (performance.navigation && performance.navigation.type === 1) {
      isReload = true;
    }

    console.log('Reload detection:', { 
      isReload, 
      hasState: !!location.state, 
      skipWelcome,
      step: locState.step 
    });

    // On reload, ALWAYS reset to step 0
    // BUT: If we have navigation state with skipWelcome, it's NOT a reload - it's programmatic navigation
    if (isReload && !skipWelcome) {
      console.log('Actual page reload detected - resetting to step 0');
      setWasReloaded(true);
      setActiveStep(0);
      // wipe out any skipWelcome/step in history state
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []); // run once on mount

  return (
    <>
    {!isAuthorized?(      
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 10000 }}
          open={!isAuthorized}
        >
          <CircularProgress color="inherit" />
        </Backdrop>           
    ):(
    <>
    <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 2,
            backgroundColor: "white",
            position: "relative",
            zIndex: 1000,
            borderBottom: "1px solid #e0e0e0",
            flexShrink: 0,
          }}
        >
          <Box sx={{ pl: 4 }}>
            <img height="40" alt="logo-illustration" src="/images/Logo2.svg" />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 4, pr: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Tooltip
                title="Onboarding"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#23A26D",
                      color: "white",
                      fontSize: "0.75rem",
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#23A26D",
                    },
                  },
                }}
              >
                <img
                  src={Progression}
                  width="33"
                  height="33"
                  alt="Progression"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
              <Typography sx={{ fontSize: "0.875rem", color: "#23A26D" }}>
                {`${Math.round(progressPercent)}%`}
              </Typography>
            </Box>
            <Typography sx={{ color: "text.secondary", fontSize: "0.875rem" }}>
              {/* Need help? */}
            </Typography>
            {/* <Button
              variant="outlined"
              size="small"
              startIcon={
                <Icon
                  icon="tabler:headphones"
                  color={theme.palette.text.secondary}
                  width={20}
                  height={20}
                />
              }
              sx={{
                borderColor: "grey.500",
                color: "text.secondary",
              }}
            > */}
            {/* Contact us */}
            {/* </Button> */}
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative",
          }}
        >
         
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                backgroundImage: `url(${backgroundpath[activeStep]})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "#fff",
              }}
            >
              <RegisterMultiStepsWizard setMainStep={setActiveStep} navigate={navigate} />
            </Box>
          
        </Box>
      </Box>
    </>)}    
    </>
  );
};

export default RegisterMultiSteps;
